// CookieTable.jsx
import React from "react";

export default function CookieTable({ data }) {
  return (
    <div className="overflow-x-auto rounded-lg">
      <table className="w-fit bg-white divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            {["Type of Cookie", "Purpose"].map((heading) => (
              <th
                key={heading}
                className="pl-1 pr-20 py-3 text-left text-sm font-bold text-gray-700 uppercase tracking-wider"
              >
                {heading}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="divide-y divide-gray-200">
          {data.map((cookie) => (
            <tr key={cookie.id} className="bg-white">
              <td className="px-0 py-4 whitespace-nowrap text-sm">
                <span className="font-bold">{cookie.name}</span>
              </td>
              <td className="px-0 py-4 whitespace-nowrap text-sm text-gray-800">
                {cookie.purpose}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// // CookieTable.jsx
// import React from "react";

// export default function CookieTable({ data }) {
//   return (
//     <div className="overflow-x-auto rounded-lg">
//       <table className="min-w-full bg-white divide-y divide-gray-200">
//         <thead className="bg-gray-50">
//           <tr>
//             {[
//               "Cookie ID",
//               "Company Name",
//               "3rd party or internal",
//               "Use",
//               "Lifespan",
//             ].map((heading) => (
//               <th
//                 key={heading}
//                 className="pl-1 py-3 text-left text-sm font-bold text-gray-700 uppercase tracking-wider"
//               >
//                 {heading}
//               </th>
//             ))}
//           </tr>
//         </thead>

//         <tbody className="divide-y divide-gray-200">
//           {data.map((cookie) => (
//             <tr key={cookie.id} className="bg-white">
//               <td className="pl-4 py-4 whitespace-nowrap text-md text-gray-800">
//                 {cookie.id}
//               </td>
//               <td className="px-0 py-4 whitespace-nowrap text-sm">
//                 <a
//                   href={cookie.company.url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-blue-600 hover:underline"
//                 >
//                   {cookie.company.name}
//                 </a>
//               </td>
//               <td className="px-0 py-4 whitespace-nowrap text-sm text-gray-800">
//                 {cookie.party}
//               </td>
//               <td className="px-0 py-4 text-sm text-gray-800">{cookie.use}</td>
//               <td className="pr-4 py-4 whitespace-nowrap text-sm text-gray-800">
//                 {cookie.lifespan}
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// }
